module.exports = __webpack_public_path__ + "static/media/29DUNON5.aa0946c3.jpg";